import React, { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FileAbout } from '../../../../types/common';
import { FloalaEditor } from '../../../components/FloalaEditor';
import { UpdatePopupDto } from '../../../../types/popup';

interface MobilePageEditProps {
  form: UseFormReturn<UpdatePopupDto>;
}

export const MobilePageEdit: FC<MobilePageEditProps> = ({ form }) => {
  return (
    <div className="flex justify-between">
      <div className="w-full">
        <FloalaEditor
          imageType={FileAbout.POPUP_MOBILE}
          defaultValue={form.getValues().mobileContents}
          onChange={(content) => form.setValue('mobileContents', content)}
        />
      </div>
    </div>
  );
};
